<template>
  <VaNavbar class="app-layout-navbar py-0 px-0" :style="navbarStyle">
    <template #left>
      <div class="left">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="GlobalStore.toggleSidebar"
          />
        </Transition>
        <RouterLink class="header-logo" to="/" aria-label="JTP">
          <img v-if="logoSrc" :src="logoSrc" alt="JTP" />
        </RouterLink>
      </div>
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { storeToRefs } from "pinia"
import { useI18n } from "vue-i18n"
import { useGlobalStore } from "../../stores/global-store"
import AppNavbarActions from "./components/AppNavbarActions.vue"

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()
const { isSidebarMinimized } = storeToRefs(GlobalStore)
const { locale } = useI18n()

const logos = import.meta.glob("@/assets/culture/header/*.png", { eager: true, import: "default" })

const logoSrc = computed<string>(() => {
  return (
    GlobalStore.getCustomLogoUrl("Logo.Header", locale.value) ??
    GlobalStore.getCustomLogoUrl("Logo.Header", "") ??
    (logos[`/src/assets/culture/header/${locale.value}.png`] as string | undefined) ??
    (logos["/src/assets/culture/header/en-US.png"] as string | undefined) ??
    ""
  )
})

const bannerSrc = computed<string>(() => {
  return (
    GlobalStore.getCustomLogoUrl("Logo.Banner", locale.value) ??
    GlobalStore.getCustomLogoUrl("Logo.Banner", "") ??
    "/images/backgroundHeaderImage_newCulture.png"
  )
})

const navbarStyle = computed(() => ({
  backgroundImage: `url('${bannerSrc.value}')`,
  backgroundColor: "var(--va-background-primary)",
}))
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}

.header-logo {
  display: flex;
  align-items: center;

  img {
    max-height: 40px;
  }
}
</style>
